import React from 'react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Search, CheckCircle, Database } from 'lucide-react';
interface EmptyStateProps {
  type: 'no-leads' | 'no-anomalies' | 'no-data';
  onClearFilters?: () => void;
}
export function EmptyState({
  type,
  onClearFilters
}: EmptyStateProps) {
  const content = {
    'no-leads': {
      icon: <Search className="w-12 h-12 text-slate-300" data-id="element-59" />,
      title: 'No leads found',
      description: 'There are no leads matching your current filters and timeframe.',
      action: onClearFilters ? <Button variant="outline" onClick={onClearFilters} className="mt-4" data-id="element-60">
          Clear Filters
        </Button> : null
    },
    'no-anomalies': {
      icon: <CheckCircle className="w-12 h-12 text-emerald-400" data-id="element-61" />,
      title: 'All clear!',
      description: 'No anomalies found. All leads are properly routed and enrolled in campaigns.',
      action: onClearFilters ? <Button variant="outline" onClick={onClearFilters} className="mt-4" data-id="element-62">
          View All Leads
        </Button> : null
    },
    'no-data': {
      icon: <Database className="w-12 h-12 text-slate-300" data-id="element-63" />,
      title: 'No campaign data',
      description: 'Campaign and drip enrollment data is currently unavailable.',
      action: <Button variant="outline" className="mt-4" data-id="element-64">
          Retry Connection
        </Button>
    }
  };
  const {
    icon,
    title,
    description,
    action
  } = content[type];
  return <Card className="flex flex-col items-center justify-center p-12 text-center border-dashed border-2 border-slate-200 bg-slate-50/50" data-id="element-65">
      <div className="bg-white p-4 rounded-full shadow-sm mb-4" data-id="element-66">{icon}</div>
      <h3 className="text-lg font-semibold text-slate-900 mb-1" data-id="element-67">{title}</h3>
      <p className="text-sm text-slate-500 max-w-sm" data-id="element-68">{description}</p>
      {action}
    </Card>;
}